import React from 'react'

const React_Coding_Practice_41 = () => {
  return (
    <div>
      <h1>Coding Pratice 41</h1>
    </div>
  )
}

export default React_Coding_Practice_41
